/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ReptileInputs */

const en_val_reptile = /** @type {(inputs: Val_ReptileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reptile`)
};

const es_val_reptile = /** @type {(inputs: Val_ReptileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reptil`)
};

const fr_val_reptile = /** @type {(inputs: Val_ReptileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reptile`)
};

const de_val_reptile = /** @type {(inputs: Val_ReptileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reptil`)
};

const ja_val_reptile = /** @type {(inputs: Val_ReptileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`爬虫類`)
};

const zh_val_reptile = /** @type {(inputs: Val_ReptileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`爬行动物`)
};

const ar_val_reptile = /** @type {(inputs: Val_ReptileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زواحف`)
};

const id_val_reptile = /** @type {(inputs: Val_ReptileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reptil`)
};

const it_val_reptile = /** @type {(inputs: Val_ReptileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rettile`)
};

const ru_val_reptile = /** @type {(inputs: Val_ReptileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рептилия`)
};

const pt_val_reptile = /** @type {(inputs: Val_ReptileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réptil`)
};

const ko_val_reptile = /** @type {(inputs: Val_ReptileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파충류`)
};

/**
* | output |
* | --- |
* | "Reptile" |
*
* @param {Val_ReptileInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_reptile = /** @type {((inputs?: Val_ReptileInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ReptileInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_reptile(inputs)
	if (locale === "es") return es_val_reptile(inputs)
	if (locale === "fr") return fr_val_reptile(inputs)
	if (locale === "de") return de_val_reptile(inputs)
	if (locale === "ja") return ja_val_reptile(inputs)
	if (locale === "zh") return zh_val_reptile(inputs)
	if (locale === "ar") return ar_val_reptile(inputs)
	if (locale === "id") return id_val_reptile(inputs)
	if (locale === "it") return it_val_reptile(inputs)
	if (locale === "ru") return ru_val_reptile(inputs)
	if (locale === "pt") return pt_val_reptile(inputs)
	return ko_val_reptile(inputs)
});